export default {"src":"/_next/static/media/help.7b7cf2f4.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};